import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded'
import PersonChatRoundedIcon from '@mui/icons-material/PersonRounded'
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded'
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded'
import IntegrationInstructionsRoundedIcon from '@mui/icons-material/IntegrationInstructionsRounded'
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded'
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded'
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded'
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded'
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded'
import ReviewsRoundedIcon from '@mui/icons-material/ReviewsRounded'
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded'
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded'
import DeleteSweepRoundedIcon from '@mui/icons-material/DeleteSweepRounded'
import type { SvgIconComponent } from '@mui/icons-material'

import type { UserRole } from '@/types/auth'

export const ROUTES = {
  login: '/login',
  dashboard: '/dashboard',
  analytics: '/analytics',
  conversations: '/conversations',
  myChats: '/my-chats',
  conversationDetail: (conversationId: string) => `/conversations/${conversationId}`,
  users: '/users',
  roles: '/roles',
  agents: '/agents',
  widgets: '/widgets',
  ai: '/ai',
  knowledgeBase: '/knowledge-base',
  integrations: '/integrations',
  feedbacks: '/feedbacks',
  settings: '/settings',
  databaseCleanup: '/database-cleanup',
} as const

export interface NavItemConfig {
  key: string
  label: string
  to: string
  icon: SvgIconComponent
  roles?: UserRole[]
  permission?: string
}

export const NAV_ITEMS: NavItemConfig[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    to: ROUTES.dashboard,
    icon: SpaceDashboardRoundedIcon,
    roles: ['admin', 'agent', 'super_admin'],
  },
  {
    key: 'conversations',
    label: 'Conversations',
    to: ROUTES.conversations,
    icon: ChatBubbleOutlineRoundedIcon,
    roles: ['admin', 'agent', 'super_admin'],
  },
  {
    key: 'myChats',
    label: 'My Chats',
    to: ROUTES.myChats,
    icon: PersonChatRoundedIcon,
    roles: ['admin', 'agent', 'super_admin'],
  },
  {
    key: 'users',
    label: 'Users',
    to: ROUTES.users,
    icon: ManageAccountsRoundedIcon,
    permission: 'users:read',
  },
  {
    key: 'roles',
    label: 'Roles',
    to: ROUTES.roles,
    icon: SecurityRoundedIcon,
    permission: 'roles:read',
  },
  {
    key: 'agents',
    label: 'Agents',
    to: ROUTES.agents,
    icon: PeopleAltRoundedIcon,
    permission: 'agents:read',
  },
  {
    key: 'widgets',
    label: 'Widgets',
    to: ROUTES.widgets,
    icon: WidgetsRoundedIcon,
    permission: 'widgets:read',
  },
  {
    key: 'ai',
    label: 'AI Management',
    to: ROUTES.ai,
    icon: SmartToyRoundedIcon,
    permission: 'ai:read',
  },
  {
    key: 'knowledgeBase',
    label: 'Knowledge Base',
    to: ROUTES.knowledgeBase,
    icon: LibraryBooksRoundedIcon,
    permission: 'knowledge-base:read',
  },
  {
    key: 'integrations',
    label: 'Integrations',
    to: ROUTES.integrations,
    icon: IntegrationInstructionsRoundedIcon,
    permission: 'integrations:read',
  },
  {
    key: 'analytics',
    label: 'Analytics',
    to: ROUTES.analytics,
    icon: InsightsRoundedIcon,
    permission: 'analytics:read',
  },
  {
    key: 'feedbacks',
    label: 'Feedbacks',
    to: ROUTES.feedbacks,
    icon: ReviewsRoundedIcon,
    permission: 'feedbacks:read',
  },
  {
    key: 'settings',
    label: 'Settings',
    to: ROUTES.settings,
    icon: ConstructionRoundedIcon,
    permission: 'settings:update',
  },
  {
    key: 'databaseCleanup',
    label: 'Database Cleanup',
    to: ROUTES.databaseCleanup,
    icon: DeleteSweepRoundedIcon,
    permission: 'settings:update',
  },
]
